<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{ on }">
        <v-btn
          color="white"
          rounded
          block
          v-on="on"
        >
          Cambiar de Categoría
          <v-spacer></v-spacer>
          <v-icon color="#1FE8D9">keyboard_arrow_down</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Categorias</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-list>
          <v-list-group
            v-for="item in items"
            :key="item.id"
            :value="isActive(item.slug)"
            no-action
          >
            <template v-slot:activator>
              <v-list-tile>
                <v-list-tile-avatar size="20">
                  <img :src="item.image">
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>

            <v-list-tile
              v-for="subcategory in item.subcategories"
              :key="subcategory.id"
              @click="goTo(item.slug, subcategory.slug)"
            >
              <v-list-tile-content>
                <v-list-tile-title class="ml-2">{{ subcategory.name }}</v-list-tile-title>
              </v-list-tile-content>

              <v-list-tile-action>
                <!-- <v-icon>{{ subcategory.action }}</v-icon> -->
              </v-list-tile-action>
            </v-list-tile>
          </v-list-group>
        </v-list>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      items: []
    }
  },
  methods: {
    ...mapActions("helpcenter", ["fetchCategories"]),
    isActive(slug) {
      return this.$route.params.category === slug
    },
    goTo(categorySlug, subcategorySlug) {
      this.$router.push(`/centro-de-ayuda/${categorySlug}/${subcategorySlug}`)
      this.dialog = false
    }
  },
  async created() {
    const res = await this.fetchCategories()
    this.items = res
  }
}
</script>
<style>

  .v-list__group__header__append-icon .v-icon {
    color: #1FE8D9;
  }

  .v-list__group--active .v-list__group__header__append-icon .v-icon {
    color: #1FE8D9;
  }

</style>